import ConnectedSIS from './ConnectedSIS'

export default ConnectedSIS
